export enum SortingOrderEnum {
  ASC = 'asc',
  DESC = 'desc',
}
